module.exports = __webpack_public_path__ + "static/media/figure-5b.f7c928d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/faq/change-batteries/figure-5b.jpg
// module id = 1181
// module chunks = 0